// 充值
const cost = resolve => require(['../view/cost/index'], resolve)
const costList = resolve => require(['../view/cost/list'], resolve)
// 信用卡
const credit = resolve => require(['../view/credit/index'], resolve)
const creditList = resolve => require(['../view/credit/list'], resolve)
const apply = resolve => require(['../view/credit/apply'], resolve)
const kill = resolve => require(['../view/home/kill'], resolve)
const dou = resolve => require(['../view/home/dou'], resolve)
const brands = resolve => require(['../view/thirdShop/brands'], resolve)
const brand = resolve => require(['../view/thirdShop/brand'], resolve)
const routes = [
  {
    path: '/cost',
    name: 'cost',
    component: cost,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/costList',
    name: 'costList',
    component: costList,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/credit',
    name: 'credit',
    component: credit,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/credit/apply',
    name: 'creditapply',
    component: apply,
    meta: {
      needLogin: true
      // requireAuth: true
    }
  },
  {
    path: '/creditList',
    name: 'creditList',
    component: creditList,
    meta: {
      keepAlive: true,
      needLogin: true
    }
  },
  {
    path: '/kill',
    name: 'kill',
    component: kill,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/dou',
    name: 'dou',
    component: dou,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/brands',
    name: 'brands',
    component: brands,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/brand',
    name: 'brand',
    component: brand,
    meta: {
      keepAlive: true
    }
  }
]
export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/thiird.js